import { t } from 'i18next';
import React from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { FaPen, FaSearch } from 'react-icons/fa';
import { IoIosVideocam } from 'react-icons/io';
import { RiDeleteBin6Line } from 'react-icons/ri';

enum SpecialistStatus {
  Schedule = 'Schedule',
  Cancel = 'Cancel'
}

const mockData = [
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  },
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  },
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  },
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  },
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  },
  {
    name: 'Brian Homos',
    email: 'brian@gmail.com',
    telephone: '+55 (11) 98765-0078',
    schedule_date: '20/04/2022',
    status: SpecialistStatus.Schedule,
    message: 'Optional message'
  }
];

const SpecialistsScreen: React.FunctionComponent = () => {
  return (
    <>
      <div className="flex w-full flex-row justify-between border-b-[2px] pb-3">
        <div className="flex flex-col">
          <h2 className="text-xl font-bold text-[#0C1FAA]">{t('others.othCompanies')}</h2>
          <span className="font-light text-[#727272]">{t('others.othScheduleSpecialist')}</span>
        </div>

        <div className="flex flex-row items-center gap-4">
          <span>{t('others.othSelectPeriod')}</span>

          <div className="flex flex-row items-center gap-2 rounded-lg border-2 border-[#C7D3D9] bg-white p-2">
            <select name="" id="" className="bg-transparent text-[#373D43] outline-none">
              <option value="" defaultChecked disabled>
                {t('others.othMonth')}
              </option>
              <option value="0">{t('others.othJuly')}</option>
              <option value="1">{t('others.othJune')}</option>
            </select>
          </div>

          <div className="flex flex-row items-center gap-2 rounded-lg border-2 border-[#C7D3D9] bg-white p-2">
            <select name="" id="" className="bg-transparent text-[#373D43] outline-none">
              <option value="" defaultChecked disabled>
                Year
              </option>
              <option value="0">2023</option>
              <option value="1">2022</option>
            </select>
          </div>
        </div>
      </div>

      <div className="mt-8 rounded-md bg-white px-4 py-4">
        <div className="mb-2 flex flex-row justify-between border-b-[2px] px-4 pb-3">
          <h3 className="text-lg font-medium">{t('others.othUsers')}</h3>

          <div className="flex flex-row items-center gap-4">
            <div className="flex flex-row items-center gap-2 rounded-lg border-2 border-[#C7D3D9] p-2">
              <FaSearch />
              <input placeholder="{ t('others.othSearchUsers') }" className="placeholder-[#373D43] outline-none" />
            </div>

            <button className="flex h-14 w-44 items-center justify-center gap-3 rounded-lg bg-[#0C1FAA] text-white">
              <AiOutlinePlusCircle />
              New service
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left font-medium">{t('labels.lblFirstName')}</th>
                <th className="px-4 py-2 text-left font-medium">{t('labels.lblEmail')}</th>
                <th className="px-4 py-2 text-left font-medium">Telephone</th>
                <th className="px-4 py-2 text-left font-medium">Schedule Date</th>
                <th className="px-4 py-2 text-left font-medium">{t('labels.lblStatus')}</th>
                <th className="px-4 py-2 text-left font-medium">Message</th>
                <th className="px-4 py-2 text-left font-medium">{t('labels.lblActions')}</th>
              </tr>
            </thead>
            <tbody>
              {mockData.map((data, index) => (
                <tr className="border-b-[2px]" key={index}>
                  <td className="px-4 py-2 text-sm">{data.name}</td>
                  <td className="px-4 py-2 text-sm">{data.email}</td>
                  <td className="px-4 py-2 text-sm">{data.telephone}</td>
                  <td className="px-4 py-2 text-sm">{data.schedule_date}</td>
                  {data.status === SpecialistStatus.Schedule ? (
                    <td className="px-4 py-2 text-sm font-bold text-[#06C051]">{t('others.othComplete')}</td>
                  ) : (
                    <td className="px-4 py-2 text-sm font-bold text-[#FF0000]">{t('others.othComplete')}</td>
                  )}
                  <td className="px-4 py-2">{data.message}</td>
                  <td className="px-4 py-2 text-sm">
                    <div className="flex flex-row gap-4 p-1">
                      <button className="flex items-center justify-center rounded-lg border-2 border-[#8004BB] bg-transparent p-2">
                        <IoIosVideocam color="#8004BB" />
                      </button>
                      <button className="flex items-center justify-center rounded-lg border-2 border-[#0C1FAA] bg-transparent p-2">
                        <FaPen color="#0C1FAA" />
                      </button>
                      <button className="flex items-center justify-center rounded-lg border-2 border-[#FF2828] bg-transparent p-2">
                        <RiDeleteBin6Line color="#FF2828" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 flex justify-between px-4">
          <div className="flex items-center">
            <p>{t('others.othRows')}</p>
            <div className="ml-4 rounded border-[2px] border-[#000] px-[16px] py-[6px]">{mockData?.length}</div>
          </div>
          <div className="flex items-center">
            <p>{t('others.othRegisterOfNumbers')}:</p>
            <div className="ml-2 font-medium">233</div>
          </div>
        </div>
      </div>
    </>
  );
};

export { SpecialistsScreen };
